import { useQuery } from "@tanstack/react-query";
import { HTTP_ENDPOINTS, QUERY_KEYS } from "../../consts/api";
import { http } from "../../services/HttpService";

function createPatientByPatternQueryKey(pattern) {
  return [QUERY_KEYS.patientByPattern, pattern];
}

export function usePatientByPatternQuery({ pattern }, options = {}) {
  return useQuery(
    createPatientByPatternQueryKey(pattern),
    () => http.get(HTTP_ENDPOINTS.getPatientByPattern(pattern)),
    options,
  );
}
